<template>
  <div class="mains">
    <div class="campus">
      功能模块
      <span>></span>
      <span @click="sentencepracticeear0">趣跟读</span>
      <span>></span>
      <router-link to>上传绘本</router-link>
    </div>
    <div class="xiaoqu">
      <el-card :span="24">
        <div class="grid-content">
          <el-dialog class="yl_shanka" title="预览绘本" :visible.sync="addStudents">
            <div class="form_1 form_1_1 yulan_0list scrollbarStyle">
              <div class="yulan_name">
                {{ yl_name }}
                <span>（ 语句数：{{ yl_name_dc }} 句 ）</span>
              </div>
              <div v-for="(item, index) in yulan_list" :key="index">
                <div class="yl_xunxu">{{ index + 1 }}.</div>
                <div class="yl_neirong">
                  <div>语句： {{ item.english }}</div>
                  <div>翻译： {{ item.chinese }}</div>
                  <div>
                    <img :src="item.picurl" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </el-dialog>
        </div>

        <div class="xiaoqu_1">上传绘本</div>
        <div class="shenzhong">
          <i class="img_1"> <img src="@/assets/img/education-manage/campus/shenzhong.png" alt /> </i>
          您所上传制作的绘本练习可直接进行句子及图片、音频的上传。
        </div>
        <div class="form_1 kbfm">
          <el-form ref="forms" :model="form" :rules="FormRules" label-width="5.20833vw">
            <el-form-item label="名称" prop="name">
              <i>
                <img src="@/assets/img/education-manage/campus/bitian.png" class="lianzi1" alt />
              </i>
              <el-input v-model="form.name" placeholder="请输入名称 ( 不超过12字 )" :disabled="this.show" @blur="blur" @keyup.enter.native="$event.target.blur"></el-input>
              <div class="shangchuan_yinyue">
                <el-button type="primary" class="my-10" @click="updateChapter1">
                  重命名
                </el-button>
              </div>
            </el-form-item>
            <el-form-item label="顺序" prop="seqnum">
              <i>
                <img src="@/assets/img/education-manage/campus/bitian.png" class="lianzi1" alt />
              </i>
              <el-input v-model="form.seqnum" placeholder="请输入顺序 ( 阿拉伯数字 )" :disabled="this.show1" @blur="blur_seq" @keyup.enter.native="$event.target.blur"></el-input>
              <div class="shangchuan_yinyue">
                <el-button type="primary" class="my-10" @click="updateChapter2">
                  重置
                </el-button>
              </div>
            </el-form-item>
            <el-form-item label="上传绘本" class="shangchuan_bg1" prop="orgcode">
              <i>
                <img src="@/assets/img/education-manage/campus/bitian.png" alt />
              </i>
              <el-input v-model="form.orgcode" placeholder="请输入您上传的绘本名称" @keyup.enter.native="daoru_add"></el-input>
              <div class="shangchuan_yinyue">
                <el-button type="primary" class="my-10" @click="daoru_add">
                  制作绘本
                </el-button>
              </div>
            </el-form-item>

            <el-form-item label prop="orgcode" class="shangchuan_bg">
              <div class="grid-content">
                <div class="zsbg huiben0">
                  <el-table :data="tableData" border style="width: 62.8125vw">
                    <el-table-column prop="title" label="绘本名称">
                      <template slot-scope="scope1">
                        <!-- {{ scope1.row }} -->
                        <input size="small" class="yp_name" :class="scope1.row.selected ? 'yp_name2' : 'yp_name1'" v-model="scope1.row.title" :disabled="scope1.row.selected" :id="scope1.row.selected ? '' : 'inputId'"
                          @blur="blur1(scope1.$index, tableData)" @keyup.13="blur1(scope1.$index, tableData)" />
                      </template>
                    </el-table-column>
                    <el-table-column prop="picurl" label="封面" max-width="100">
                      <template slot-scope="scope0">
                        <!-- {{ scope0.row.picurl }} -->
                        <div v-if="scope0.row.picurl">
                          <img :src="scope0.row.picurl" />
                        </div>
                        <div v-else>无</div>
                      </template>
                    </el-table-column>
                    <el-table-column label="绘本排序">
                      <template slot-scope="scopes">
                        <el-input v-model="scopes.row.seqnum" class="yp_paixu" @blur="blur1(scopes.$index, tableData)" @keyup.enter.native="
                            $event.target.blur(scopes.$index, tableData)
                          "></el-input>
                      </template>
                    </el-table-column>

                    <el-table-column label="操作">
                      <template slot-scope="stData">
                        <el-button type="text" @click="chong(stData.$index, tableData)">
                          重命名
                        </el-button>
                        <el-button type="text" @click="zhizuo_py(stData.row.id)">
                          新建
                        </el-button>
                        <el-button type="text" @click="zhizuo_py1(stData.row.id)">
                          修改
                        </el-button>
                        <el-button type="text" @click="deleteSentencePractice(stData.row.id)">
                          删除
                        </el-button>
                        <el-button type="text" @click="yulan(stData.row.id)">
                          预览
                        </el-button>
                        <el-upload class="upload-demo" style="display: inline-block; margin-left: 0.52083vw" action="" :show-file-list="false" :http-request="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
                          <el-button type="text" @click="shangchuan0(stData.row.id)">
                            封面
                          </el-button>
                        </el-upload>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </div>
            </el-form-item>
          </el-form>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
export default {
  name: 'sentencepracticeear',
  data() {
    return {
      form: {
        name: '',
        orgcode: '',
        seqnum: '',
      },
      FormRules: {},
      yl_name: '',
      yl_name_dc: '',
      show: true,
      show1: true,
      tempImg: '',
      banji_id: {},
      tableData: [],
      gh_yp: '',
      addStudents: false,
      yulan_list: [],
      fengmian: '',
      voiceurl: '',
      shangchuan_id: '',
    };
  },
  created() {
    if (!this.$store.state.sentencepractice) {
      this.$router.push({ name: 'sentencepractice' });
      return this.$message.error('您当前的章节数据获取失败！');
    }
    this.banji_id = this.$store.state.sentencepractice;

    this.selectSentencePractice();
    this.selctChapterandsectionById();
  },
  destroyed() {
    localStorage.removeItem('sentencepractice');
  },
  watch: {},
  methods: {
    sentencepracticeear0() {
      this.$store.commit('sentencepracticeear0', this.banji_id.bookid);
      this.$router.push({ name: 'sentencepractice' });
    },
    shangchuan0(id) {
      // console.log(id)
      this.shangchuan_id = id;
    },

    handleAvatarSuccess(data) {
      // console.log(data)
      let orgid = window.sessionStorage.getItem('orgid');
      let formData = new FormData();
      formData.append('file', data.file);
      formData.append('orgid', orgid);
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/sentencepractice/uploadimage',
        method: 'POST',
        data: formData,
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          // console.log(result)
          if (result.data.code !== 0) {
            return this.$message.error(result.data.message);
          }
          for (var i = 0; i < this.tableData.length; i++) {
            if (this.shangchuan_id === this.tableData[i].id) {
              // console.log(this.tableData[i])
              let url0 = result.data.data;
              this.tableData[i].picurl = url0;
              let pro = this.$http({
                url: '/edu/sentencepractice/updateSentencePractice',
                method: 'POST',
                data: {
                  id: this.shangchuan_id,
                  picurl: url0,
                },
                headers: {
                  Authorization: 'Bearer ' + token,
                },
              });
              pro
                .then((result) => {
                  // console.log(result)
                  if (result.data.code !== 0) {
                    return this.$message.error(result.data.message);
                  }
                  return this.$message.success('修改封面图片成功！');
                })
                .catch((err) => {
                  // console.log(err)
                  return this.$message.error('修改封面图片失败：' + err);
                });
            }
          }
        })
        .catch((err) => {
          // console.log('error===============')
          this.$message.error('系统错误：' + err);
        });
    },

    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg';
      const isPNG = file.type === 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 1;

      if (!isJPG && !isPNG) {
        this.$message.error('上传图片只能是 JPG/PNG 格式!');
        return false;
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 1MB!');
        return false;
      }
      return isJPG | isPNG && isLt2M;
    },

    zhizuo_py(sentencepracticeear) {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      // let orgid = window.sessionStorage.getItem('orgid')
      let pro = this.$http({
        url: '/edu/sentencepractice/getSentencePracticeViewById/' + sentencepracticeear,
        method: 'GET',
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          // console.log(result)
          if (result.data.code !== 0) {
            return this.$message.error(result.data.message);
          }
          if (result.data.data.length === 0) {
            this.$store.commit('sentencepracticeear', sentencepracticeear);
            this.$store.commit('sentencepracticeears', this.banji_id);
            this.$router.push({ name: 'sentencepracticeDubList' });
          } else {
            return this.$message.error('您的绘本已有数据！');
          }
        })
        .catch((err) => {
          // console.log(err)
          return this.$message.error('新建绘本失败：' + err);
        });
    },

    zhizuo_py1(sentencepracticeear) {
      this.$store.commit('sentencepracticeear1', sentencepracticeear);
      this.$store.commit('sentencepracticeearbs', this.banji_id);
      this.$router.push({ name: 'sentencepracticeupdate' });
    },

    yulan(id) {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      // let orgid = window.sessionStorage.getItem('orgid')
      let pro = this.$http({
        url: '/edu/sentencepractice/getSentencePracticeViewById/' + id,
        method: 'GET',
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          // console.log(result)
          if (result.data.code !== 0) {
            return this.$message.error(result.data.message);
          }
          this.yulan_list = result.data.data;
          for (var i = 0; i < this.tableData.length; i++) {
            if (this.tableData[i].id === id) {
              this.yl_name = this.tableData[i].title;
            }
          }
          this.yl_name_dc = result.data.data.length;
          if (result.data.data.length !== 0) {
            this.addStudents = true;
          } else {
            return this.$message.error('您的绘本当前没有数据！');
          }
        })
        .catch((err) => {
          // console.log(err)
          return this.$message.error('预览绘本失败：' + err);
        });
    },

    // 章节重命名
    updateChapter1() {
      this.show = false;
    },
    updateChapter2() {
      this.show1 = false;
    },
    blur() {
      this.show = true;
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      // let orgid = window.sessionStorage.getItem('orgid')
      let pro = this.$http({
        url: '/edu/chapterandsection/updateChapter',
        method: 'POST',
        data: {
          id: this.banji_id.id,
          title: this.form.name,
        },
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          // console.log(result)
          if (result.data.code !== 0) {
            return this.$message.error(result.data.message);
          }
          return this.$message.success('章节重命名成功！');
        })
        .catch((err) => {
          // console.log(err)
          return this.$message.error('章节重命名失败：' + err);
        });
    },
    blur_seq() {
      this.show1 = true;
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      // let orgid = window.sessionStorage.getItem('orgid')
      let pro = this.$http({
        url: '/edu/chapterandsection/updateChapter',
        method: 'POST',
        data: {
          id: this.banji_id.id,
          seqnum: this.form.seqnum,
        },
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          // console.log(result)
          if (result.data.code !== 0) {
            return this.$message.error(result.data.message);
          }
          return this.$message.success('序号重置成功！');
        })
        .catch((err) => {
          // console.log(err)
          return this.$message.error('序号重置失败：' + err);
        });
    },
    // 绘本重命名
    chong(index, rows) {
      // console.log(index)
      // console.log(rows)
      // console.log(rows[index])
      rows[index].selected = false;
      document.getElementById('inputId').focus();
    },

    blur1(index, rows) {
      // console.log(rows[index])
      rows[index].selected = true;

      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      // let orgid = window.sessionStorage.getItem('orgid')
      let pro = this.$http({
        url: '/edu/sentencepractice/updateSentencePractice',
        method: 'POST',
        data: {
          id: rows[index].id,
          title: rows[index].title,
          seqnum: rows[index].seqnum,
        },
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          // console.log(result)
          if (result.data.code !== 0) {
            return this.$message.error(result.data.message);
          }
          this.selectSentencePractice();
          return this.$message.success('绘本修改成功！');
        })
        .catch((err) => {
          // console.log(err)
          return this.$message.error('绘本修改失败：' + err);
        });
    },

    // 制作绘本
    daoru_add() {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let orgid = window.sessionStorage.getItem('orgid');
      if (this.form.orgcode === '') {
        return this.$message.error('请首先输入该绘本的名称！');
      }
      let pro = this.$http({
        url: '/edu/sentencepractice/addSentencePractice',
        method: 'POST',
        data: {
          title: this.form.orgcode,
          chapterid: this.banji_id.id,
          bookid: this.banji_id.bookid,
          orgid: orgid,
        },
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          // console.log(result)
          if (result.data.code !== 0) {
            return this.$message.error(result.data.message);
          }
          this.form.orgcode = '';
          this.selectSentencePractice();
          return this.$message.success('制作绘本成功!');
        })
        .catch((err) => {
          // console.log(err)
          return this.$message.error('制作绘本失败：' + err);
        });
    },

    // 更改绘本
    genghuan(id) {
      // console.log(id)
      this.gh_yp = id;
    },

    // 删除绘本
    deleteSentencePractice(id) {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      this.$confirm('确认要删除吗?', '删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        // axios请求服务器端实现删除
        let pro = this.$http({
          url: '/edu/sentencepractice/deleteSentencePractice/' + id,
          method: 'POST',
          headers: {
            Authorization: 'Bearer ' + token,
          },
        });
        pro
          .then((result) => {
            // console.log(result)
            if (result.data.code !== 0) {
              return this.$message.error(result.data.message);
            }
            this.selectSentencePractice();
            return this.$message.success('删除绘本成功!');
          })
          .catch((err) => {
            // console.log(err)
            return this.$message.error('删除绘本失败：' + err);
          });
      });
    },

    // 查询章节名称
    selctChapterandsectionById() {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/chapterandsection/selctChapterandsectionById/' + this.banji_id.id,
        method: 'GET',
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          // console.log(result)
          if (result.data.code !== 0) {
            return this.$message.error(result.data.message);
          }
          this.form.name = result.data.data.title;
          this.form.seqnum = result.data.data.seqnum;
        })
        .catch((err) => {
          // console.log(err)
          return this.$message.error('查询章节名称失败：' + err);
        });
    },

    // 查询绘本
    selectSentencePractice() {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let orgid = window.sessionStorage.getItem('orgid');
      let pro = this.$http({
        url: '/edu/sentencepractice/selectSentencePractice',
        method: 'POST',
        data: {
          bookid: this.banji_id.bookid,
          chapterid: this.banji_id.id,
          orgid: orgid,
        },
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          // console.log(result.data.data)
          if (result.data.code !== 0) {
            return this.$message.error(result.data.message);
          }
          this.tableData = result.data.data;
          for (var i = 0; i < this.tableData.length; i++) {
            this.tableData[i].selected = true;
            if (this.tableData[i].picurl === null) {
              // this.tableData[i].picurl = false
            }
          }
        })
        .catch((err) => {
          // console.log(err)
          return this.$message.error('查询绘本列表失败：' + err);
        });
    },
  },
};
</script>

<style lang="less">
.mains .xiaoqu .grid-content {
  .huiben0 {
    .el-table_1_column_1 {
      padding-left: 7% !important;
    }
    .el-table_1_column_2 {
      text-align: center !important;
      padding-left: 0 !important;
    }
    .el-table_1_column_4 {
      padding-right: 2% !important;
    }
    img {
      width: 79px;
      height: 42px;
    }
  }
}
</style>
